import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "validation-list" }
const _hoisted_2 = ["data-conflict-level", "onClick"]
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "column-name" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "column-item overflow-indicator" }
const _hoisted_7 = { class: "relation-class" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "relation-type" }
const _hoisted_10 = { class: "text-content" }
const _hoisted_11 = { class: "example-container" }
const _hoisted_12 = { class: "example-single" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCards, (card, cellsIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["validation-card", {
        'has-conflict': card.ifConflict,
        selected:
          _ctx.chooseCard &&
          card.columnName.join('+') === _ctx.chooseCard.columnName.join('+') &&
          card.relationType === _ctx.chooseCard.relationType,
      }]),
        key: cellsIndex,
        "data-conflict-level": card.ifConflict,
        onClick: ($event: any) => (_ctx.$emit('card-click', card))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.getTypeIcon(card.relationType),
              alt: card.relationType,
              class: "type-icon-small"
            }, null, 8, _hoisted_5),
            _createElementVNode("span", {
              class: "column-items-container",
              ref_for: true,
              ref: `cardColumnContainer-${cellsIndex}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleColumnNames(
                _ctx.getDisplayColumnNames(card),
                `card-${cellsIndex}`
              ), (col, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "column-item",
                  ref_for: true,
                  ref: `cardColumnItem-${cellsIndex}-${index}`
                }, _toDisplayString(col), 1))
              }), 128)),
              (
                _ctx.getHiddenColumnCount(
                  _ctx.getDisplayColumnNames(card),
                  `card-${cellsIndex}`
                ) > 0
              )
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "dark",
                    placement: "top",
                    "show-after": 2000,
                    content: 
                _ctx.getHiddenColumnNames(
                  _ctx.getDisplayColumnNames(card),
                  `card-${cellsIndex}`
                ).join(', ')
              ,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, " +" + _toDisplayString(_ctx.getHiddenColumnCount(
                    _ctx.getDisplayColumnNames(card),
                    `card-${cellsIndex}`
                  )), 1)
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(card.relationClass), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              (card.example && card.example.includes(';'))
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "dark",
                    placement: "top",
                    "show-after": 2000,
                    content: 
                  card.example
                    .split(';')
                    .map((line) => line.trim())
                    .join(' ')
                ,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.example.split(';'), (line, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "example-line"
                          }, _toDisplayString(line.trim()), 1))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    effect: "dark",
                    placement: "top",
                    "show-after": 2000,
                    content: card.example,
                    disabled: !card.example || card.example.length <= 50,
                    "popper-class": "custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(card.example), 1)
                    ]),
                    _: 2
                  }, 1032, ["content", "disabled"]))
            ])
          ]),
          _createElementVNode("button", {
            class: "delete-card-btn",
            onClick: _withModifiers(($event: any) => (_ctx.$emit('delete-card', card)), ["stop"])
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: "/cardpanel_icon/delete.svg",
              alt: "delete",
              class: "delete-icon"
            }, null, -1)
          ]), 8, _hoisted_13)
        ])
      ], 10, _hoisted_2))
    }), 128)),
    (_ctx.filterCards.length >= 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "validation-card-empty",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('create-rule')))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: "/cardpanel_icon/addcard.svg",
            class: "addcard-icon"
          }, null, -1),
          _createTextVNode(" Create Validation Rule ")
        ])))
      : _createCommentVNode("", true)
  ]))
}